import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store, { persistor } from "./store/Index";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./styles/fonts.css";
persistor.subscribe(() => {});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <GoogleOAuthProvider clientId="506203633596-4bl79j0svqvq0kc1njoa1tma7aisb8gn.apps.googleusercontent.com">
        <BrowserRouter>
          <App />
          {/* <PermissionProvider>
            <App />
          </PermissionProvider> */}
        </BrowserRouter>
      </GoogleOAuthProvider>
    </PersistGate>
  </Provider>
);
